import { z } from 'zod';

export const MeResponse = z.object({
  email: z.string(),
  displayName: z.string(),
  role: z.enum(['ADMIN', 'STANDARD']),
  csrfToken: z.string(),
  sessionExpiresAt: z.string(),
});
export type MeResponse = z.infer<typeof MeResponse>;
